import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { GlobalStatus } from '../../../../../../../libs/shared-models/common-models/src/lib/enum/global-status.enum';
export class VendorsDTO {
  @ApiProperty()
  // @MaxLength(7, { message: "States id allows maximum 7 characters" })
  //  @Matches(new RegExp("^[a-zA-Z0-9]+$"), '', { message: "States Code should not include these Charecters !@#$%^&*()_+{}[]:\";'<>?,./~` " })
  @IsNotEmpty({message:"Vendor id should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  vendorId?: number;
  @ApiProperty()
  @IsNotEmpty({message:"vendorCode should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  vendorCode: string;
  @ApiProperty()
  @MaxLength(15, { message: "vendorName allows maximum 15 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"),{ message:"States name should be only alpha numeric" })
  // @IsNotBlank('StatesName', { message: "States Name is not to be a white spaces" })
  vendorName: string;
  @ApiProperty()
  @IsNotEmpty({message:"gstNumber should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  gstNumber: string;
  @ApiProperty()
  @IsNotEmpty({message:"website should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  website: string;
  @ApiProperty()
  @IsNotEmpty({message:"contactPerson should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  contactPerson: string;
  @ApiProperty()
  @IsNotEmpty({message:"street should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  street: string;
  @ApiProperty()
  @IsNotEmpty({message:"appartment should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  apartment: string;
  @ApiProperty()
  @IsNotEmpty({message:"city should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  city: string;
  @ApiProperty()
  @IsNotEmpty({message:"postalCode should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  postalCode: string;
  @ApiProperty()
  @IsNotEmpty({message:"countryId should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  countryId: number;
  countryName?: string;
  @ApiProperty()
  @IsNotEmpty({message:"currencyId should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  currencyId: number;
  currencyName?: string;
  @ApiProperty()
  @IsNotEmpty({message:"privateNote should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  privateNote: string;
  @ApiProperty()
  @IsNotEmpty({message:"publicNote should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  publicNote: string;
  @ApiProperty()
  @IsNotEmpty({message:"bankAccNo should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  bankAccNo: string;
  @ApiProperty()
  @IsNotEmpty({message:"bankIfsc should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  bankIfsc: string;

  @ApiProperty()
  bankName: number;
  @ApiProperty()
  @IsNotEmpty({message:"bankBranch should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  bankBranch: string;
  @ApiProperty()
  @IsNotEmpty({message:"ContactNumber should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  contactNumber: string;
  @ApiProperty()
  @IsNotEmpty({message:"EmailId should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  emailId: string;


  @ApiProperty()
  registrationType: string;
  @ApiProperty()
  deductbleType: string;
  @ApiProperty()
  tdsDeductble: string;
  @ApiProperty()
  stateName: string;
  @ApiProperty()
  panNumber: string;
  @ApiProperty()
  category: number;

  @ApiProperty()
  isActive: boolean;

  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;

  @ApiProperty()
  @IsOptional()
  priceNeeded : GlobalStatus
}

